module.exports = __webpack_public_path__ + "static/media/macbook-mock-dribbble2.0662bcc9.png";